import { createContext } from "react";

export const CollabContext = createContext({});
